import { JobOptionTypeName, JobPlanOptionAttribute, Note } from "./index";
import { JobChoiceAttribute } from "./JobChoiceAttribute";
import { JobChoiceLocation } from "./JobChoiceLocation";
import { JobPlanOptionLocation } from "./jobplanoptionlocation";

export class JobPlanOption {
    public id: number;
    public planOptionId: number;
    public jobId: number;
    public qty: number;
    public listPrice: number;
    public optionSalesName: string;
    public optionDescription: string;
    public constructionComplete: boolean;
    public jobOptionTypeName: JobOptionTypeName;
    public isSalesIncludeOption: boolean;
    public financialOptionIntegrationKey: string;
    public optionCategoryId: number;
    public optionCategoryName: string;
    public attributes: JobPlanOptionAttribute[];
    public jobPlanOptionLocations: JobPlanOptionLocation[];
    public note: Note;
    public jobChoiceAttributes: JobChoiceAttribute[];
    public jobChoiceLocations: JobChoiceLocation[];

    constructor(jobPlanOption: JobPlanOption){
        this.id = jobPlanOption.id;
        this.planOptionId = jobPlanOption.planOptionId;
        this.jobId = jobPlanOption.jobId;
        this.qty = jobPlanOption.qty;
        this.listPrice = jobPlanOption.listPrice;
        this.optionSalesName = jobPlanOption.optionSalesName;
        this.optionDescription = jobPlanOption.optionDescription;
        this.constructionComplete = jobPlanOption.constructionComplete;
        this.jobOptionTypeName = jobPlanOption.jobOptionTypeName;
        this.isSalesIncludeOption = jobPlanOption.isSalesIncludeOption;
        this.financialOptionIntegrationKey = jobPlanOption.financialOptionIntegrationKey;
        this.optionCategoryId = jobPlanOption.optionCategoryId;
        this.optionCategoryName = jobPlanOption.optionCategoryName;
        this.attributes = jobPlanOption.attributes;
        this.jobPlanOptionLocations = jobPlanOption.jobPlanOptionLocations;
        this.note = jobPlanOption.note;
        this.jobChoiceAttributes = jobPlanOption.jobChoiceAttributes;
        this.jobChoiceLocations = jobPlanOption.jobChoiceLocations;
    }
}